'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".ErrorBanner-module_errorBanner__ME-0x{background:#ffeded;border:1px solid #e02020;border-radius:4px;box-sizing:border-box;color:#000;font-size:14px;line-height:20px;padding:16px;text-align:left}";
var styles = {"errorBanner":"ErrorBanner-module_errorBanner__ME-0x"};
styleInject["default"](css_248z, '67c4b5cf-3cc1-47b8-9018-12f05abc87f2');

exports["default"] = styles;
